module.exports = "<div class=\"authorized-container\">\n    <top-bar></top-bar>\n\n    <div class=\"container-bottom\">\n\n        <side-menu></side-menu>\n        <div class=\"inner-view-container\">\n            <breadcrumbs></breadcrumbs>\n            <edit-mode></edit-mode>\n            <sub-menu></sub-menu>\n\n            <ui-view></ui-view>\n            <dbm-shepherd-welcome-modal-starter></dbm-shepherd-welcome-modal-starter>\n        </div>\n    </div>\n\n</div>\n\n<root-circle-loader></root-circle-loader>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/authorized.tpl.html
// module id = 1722
// module chunks = 0